import usePaymentProcessing from './hooks/usePaymentProcessing'
import { getPaymentIcon } from 'containers/Payment/utils'
import usePaymentMethods from './hooks/usePaymentMethods'
import BlikPopup from 'containers/Payment/BlikPopup'
import { useState, useEffect, useRef } from 'react'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import usePopupState from 'hooks/usePopupState'
import { displayPrice } from 'utils/string'
import Loading from 'components/Loading'
import Option from 'components/Option'
import Error from 'components/Error'
import { v7 } from 'uuid'

const Payment = ({ getInvoices, grossPrice, summaryTop, summaryBottom, close }) => {
  const bottomRef = useRef(null)

  const { popup } = usePopupState()
  const [selected, select] = useState({ methodId: '' })
  const { isLoading, paymentMethods } = usePaymentMethods()
  const { isProcessing, purchase, generateBody } = usePaymentProcessing(selected, getInvoices, grossPrice, paymentMethods)

  const { t } = useTranslation('payment')

  useEffect(() => {
    if (selected.methodId) {
      bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
    }
  }, [selected.methodId])

  return (
    <>
      {popup && <div>
        {popup.type === 'blik'
          ? (() => {
            let localPaymentId = ''
            return <BlikPopup
              callback={remotePaymentId => {
                close(remotePaymentId, localPaymentId)
              }}
              getBody={code => {
                localPaymentId = v7()
                return generateBody(localPaymentId, code)
              }}
            />
          })()
          : null}
      </div>}

      <div className='payment --secondary'>
        <div className='title'>
          <div>{t('payment')}</div>
          <div>{t('chooseOneOfOptions')}</div>
        </div>

        <div className='payment__main center'>
          <div>
            <div className='payment__summary center'>
              <div>
                <div className='summary__item --primary'>
                  <div>{t('toPay')}</div>
                  <div>{displayPrice(grossPrice)}</div>
                </div>
              </div>

              <div>
                <div className='summary__item'>
                  <div>{summaryTop}</div>
                  <div>{summaryBottom}</div>
                </div>
              </div>
            </div>

            <p>{t('methodsAvailable')}</p>
            <div
              className='payment__methods'
              style={isProcessing ? { opacity: 0.5 } : undefined}>
              {paymentMethods
                ? paymentMethods.map((payment) => {
                  const { id, key, name, description, isBlocked } = payment
                  if (key === 'applepay' && !window.ApplePaySession) return null
                  const isSelected = selected.methodId === id
                  const icon = getPaymentIcon(payment)

                  return <Option
                    key={id}
                    icon={icon}
                    title={name}
                    desc={description}
                    selected={isSelected}
                    action={() => {
                      if (isBlocked || isProcessing) return
                      select({ methodId: id })
                    }} />
                })
                : isLoading
                  ? <Loading />
                  : <Error />}
            </div>

            <ArrowBtn
              enlarged
              text={t('payNow')}
              action={purchase} />

            <BackBtn
              action={() => { close() }}
            />
            <div ref={bottomRef} />
          </div>
        </div>
      </div>
    </>
  )
}

export default Payment